import React from "react"
import FormStart from "../../../form/subcategory/FormStart"
import SubCategory from "../../../../stories/_catalog/SubCategories/SubCategory"
import '../../../../css/overbox/SubCategoryInformation.css'

const NewObject = props => {
    const { handleIndex } = props

    return (
        <div className="overlayer">
            <div className="wrapOverbox">
                <div className="overbox start">
                    <FormStart object={ new SubCategory() } handleIndex={handleIndex} />
                </div>
            </div>
        </div>
    )
}

export default NewObject
